import { lazy } from "react";
import type { RouteObject } from "react-router";
import { PROFILE_ROUTES } from "@/src/profile/constants/profile-routes.constants";

const MyProfilePage = lazy(() => import("@/src/profile/pages/my-profile.page"));
const MySchedulePage = lazy(() => import("@/src/profile/pages/my-schedule.page"));

export const profileStudentRoutes: RouteObject[] = [
	{ path: PROFILE_ROUTES.myProfile, element: <MyProfilePage /> },
	{ path: PROFILE_ROUTES.mySchedule, element: <MySchedulePage /> },
];
